/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { StorageProvider } from '../services/storage.provider';


@Injectable({ providedIn: 'root' })
export class AuthProvider {
  public newspapers: any;
  public mainNewspapers: any;
  private access_newspapers: string;
  private access_main_newspapers: string;
  private profileType: string;

  public static ONLY_PRINT_ACCESS_WITH_PDF_BEFORE_DATE = '2024-09-01';
  // public static  ONLY_PRINT_ACCESS_WITH_PDF_BEFORE_DATE = '2024-11-01';
  

  constructor(private config: ConfigService, private storage: StorageProvider) {
    this.access_newspapers = storage.getStorage('access');
    this.access_main_newspapers = storage.getStorage('mainaccess');
    if (this.access_newspapers) {
      this.newspapers = this.access_newspapers.split(',');
    }
    if (this.access_main_newspapers) {
      this.mainNewspapers = this.access_main_newspapers.split(',');
    }
  }

  isAuthenticated() {
    const access_token: string = this.storage.getStorage('access_token');
    const profile: string = this.storage.getStorage('logged_profile_id');

    if (access_token && profile) {
      return true;
    } else {
      return false;
    }
  }

  hasAccessTo() {
    if (this.storage.getStorage('access') && this.storage.getStorage('access') !== undefined) {
      return this.storage.getStorage('access');
    }
    return '';
  }

  hasAccessToPrint() {
    if (this.storage.getStorage('printaccess')) {
      return this.storage.getStorage('printaccess');
    }

    return '';
  }

  hasAccessToPdf() {
    if (this.storage.getStorage('pdfaccess')) {
      return this.storage.getStorage('pdfaccess');
    }

    return '';
  }

  hasAccessToMain() {
    if (this.storage.getStorage('mainaccess')) {
      return this.storage.getStorage('mainaccess');
    }
    return '';
  }

  hasAllAccessToNewspaper(newspaperSubname: string) {
    if (this.hasAccessTo() || this.hasAccessToPrint()) {
      return ( this.hasAccessTo().includes(newspaperSubname) || this.hasAccessToPrint().includes(newspaperSubname));
    }
    
    return false;
  }

  oneMainNewspaper() {
    const main = this.storage.getStorage('mainaccess');
    let mainarray = [];
    if (main) {
      mainarray = main.split(',');
    }

    if (mainarray.length === 1) {
      return true;
    } else {
      return false;
    }
  }

  getNoAccessNewspaapers() {
    const access = this.hasAccessTo();
    let allnewspapers;
    const notallowaccess = [];
    if (access) {
      allnewspapers = this.config.getAllNewspapers();

      allnewspapers.forEach((item, index) => {
        const inAllowedAccess = access.search(item.subname);
        if (inAllowedAccess === -1) {
          notallowaccess.push(item);
        }
      });

      return notallowaccess;
    } else {
      allnewspapers = this.config.getAllNewspapers();
      return allnewspapers;
    }
  }

  getAccessNewspapers() {
    const access = this.hasAccessTo();
    const allowedAccess = [];
    let allnewspapers;
    if (access) {
      allnewspapers = this.config.getAllNewspapers();
      allnewspapers.forEach((item, index) => {
        const isInAllowedAccess = access.search(item.subname);
        if (isInAllowedAccess > -1) {
          allowedAccess.push(item);
        }
      });
    }
    return allowedAccess;
  }

  isPartiallyAuthenticated() {
    const profile = this.storage.getStorage('logged_profile_id');
    const access = this.storage.getStorage('access_token');

    if (!profile && access) {
      return true;
    } else {
      return false;
    }
  }

  logedWithNoProfiles() {
    if (this.isPartiallyAuthenticated() && this.storage.getStorage('noProfiles') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  getActiveProfile() {
    if (this.isAuthenticated) {
      return this.storage.getStorage('logged_profile_type');
    }
  }

  get getProfileType(): string {
    return (this.profileType = this.storage.getStorage('logged_profile_type'));
  }

  checkAccessOnlyWeekly(access): boolean {
    const weekly = ['week', 'mlwk', 'mwne', 'mlne', 'sema', 'woch'];
    return access.every((item) => weekly.includes(item));
  }

  checkAccessOnlyWeeklyandVideo(access): boolean {
    const video = ['mquovideo', 'actuvideo', 'week', 'mlwk', 'sema', 'woch'];
    return access.every((item) => video.includes(item));
  }

  containsNonWeeklyorVideoWithWeb(access) {
    const weeklyVideo = [ 'mquovideo', 'actuvideo', 'week', 'mlwk', 'sema', 'woch'];
    const newspaperAccess = Object.keys(access);
    let nonWeeklyWithWebAccess: string[];

    const coco = newspaperAccess.filter((item) => !weeklyVideo.includes(item));

    if (coco && coco.length > 0) {
      nonWeeklyWithWebAccess = coco.filter((item) =>
        Object.keys(access[item]).includes('website')
      );
    }

    return nonWeeklyWithWebAccess.length > 0 ? true : false;
  }
}
